export const pagination = {
  data() {
    return {
      total: null,
      flag: false
    }
  },
  methods: {
    // 条数
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize

      this.flag = true

      this.search()
    },

    // 分页
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage

      this.flag = true

      this.search()
    }
  }
}
